import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    IContactDirectory,
    IContactInternals,
    IContacts,
} from '@dxp/core/models';
import { ContactsApiService } from '@dxp/core/api';

@Injectable({
    providedIn: 'root',
})
export class ContactDirectoryService {
    readonly #contactsApiService = inject(ContactsApiService);

    fetchContactDirectories(): Observable<IContactDirectory[]> {
        return this.#contactsApiService.getContactDirectories();
    }

    fetchContactDirectory(
        top: number,
        skip: number,
        searchQuery: string | undefined,
        directory: number,
        requiresName: boolean,
        requiresEmail: boolean,
        requiresPhone: boolean,
    ): Observable<IContacts> {
        return this.#contactsApiService.getContactsByDirectory(
            directory,
            'fullName asc',
            skip,
            top,
            { requiresName, requiresPhone, requiresEmail },
            searchQuery,
        );
    }

    fetchInternalContacts(
        top: number,
        skip: number,
        searchQuery: string | undefined,
    ): Observable<IContactInternals> {
        return this.#contactsApiService.getInternalContacts(
            top,
            skip,
            searchQuery,
        );
    }
}
